import { render, staticRenderFns } from "./ApproveTable.vue?vue&type=template&id=06afbd76&scoped=true&"
import script from "./ApproveTable.vue?vue&type=script&lang=ts&"
export * from "./ApproveTable.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveTable.vue?vue&type=style&index=0&id=06afbd76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afbd76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VImg,VMenu,VSimpleTable,VTooltip})
